import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { logger, loadModule, fill, isThenable } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';

/** Tracing integration for graphql package */
var GraphQL = /*#__PURE__*/function () {
  function GraphQL() {
    _classCallCheck(this, GraphQL);
    GraphQL.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  _createClass(GraphQL, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = GraphQL.id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('GraphQL Integration is skipped because of instrumenter configuration.');
        return;
      }
      var pkg = loadModule('graphql/execution/execute.js');
      if (!pkg) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('GraphQL Integration was unable to require graphql/execution package.');
        return;
      }
      fill(pkg, 'execute', function (orig) {
        return function () {
          var scope = getCurrentHub().getScope();
          var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
            return _2.getSpan;
          }, 'call', function (_3) {
            return _3();
          }]);
          var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
            return _4.startChild;
          }, 'call', function (_5) {
            return _5({
              description: 'execute',
              op: 'graphql.execute'
            });
          }]);
          _optionalChain([scope, 'optionalAccess', function (_6) {
            return _6.setSpan;
          }, 'call', function (_7) {
            return _7(span);
          }]);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var rv = orig.call.apply(orig, [this].concat(args));
          if (isThenable(rv)) {
            return rv.then(function (res) {
              _optionalChain([span, 'optionalAccess', function (_8) {
                return _8.finish;
              }, 'call', function (_9) {
                return _9();
              }]);
              _optionalChain([scope, 'optionalAccess', function (_10) {
                return _10.setSpan;
              }, 'call', function (_11) {
                return _11(parentSpan);
              }]);
              return res;
            });
          }
          _optionalChain([span, 'optionalAccess', function (_12) {
            return _12.finish;
          }, 'call', function (_13) {
            return _13();
          }]);
          _optionalChain([scope, 'optionalAccess', function (_14) {
            return _14.setSpan;
          }, 'call', function (_15) {
            return _15(parentSpan);
          }]);
          return rv;
        };
      });
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'GraphQL';
    }
  }]);
  return GraphQL;
}();
GraphQL.__initStatic();
export { GraphQL };